import { Schema as S } from "effect";

/**
 * Search Insurers Request Schema
 *
 * Request to search statutory (GKV) insurers by name.
 */
export const SearchInsurersRequestSchema = S.Struct({
  /** Search query (insurer name or short name) */
  query: S.String,
});

export type SearchInsurersRequest = S.Schema.Type<
  typeof SearchInsurersRequestSchema
>;
